import { useContext, useEffect, useState } from 'react';

import { sendGTMEvent } from 'helpers/google-tag-manager';
import LeadsHeader from 'pages/leads/components/leads-header/leads-header';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { Container } from '@olist/templates';
import { Alert, Badge, Box, Flex, Text } from '@olist/united';

import { RootContext } from '../../components/leads-provider';
import PasswordForm from '../../components/password-form/password-form';

const CreatePasswordPage = () => {
  const { t } = useTranslation();

  const { leadProfileCookie } = useContext(RootContext);

  const [shouldShowErrorAlert, setShouldShowErrorAlert] = useState(false);

  useEffect(() => {
    sendGTMEvent('page_view', {
      user_id: leadProfileCookie?.email,
    });
  }, [leadProfileCookie]);

  const hasSignupFilled = leadProfileCookie && leadProfileCookie?.email;
  if (!hasSignupFilled) {
    return <Redirect to="/onboarding/first-steps/" />;
  }

  return (
    <Container>
      <LeadsHeader currentStep={LeadsHeader.steps.REQUIREMENTS} />
      <Flex ml={[0, 0, 0, 0]} flexDirection="row" justifyContent="space-between" mt={[0, 0, 9]}>
        <Box maxWidth="628px">
          {shouldShowErrorAlert && (
            <Alert mb={4} messages={[t`ops, the form could not be submitted. Try again`]} />
          )}
          <Text fontSize={[5, 6]} py={2} fontWeight="bold">
            {t`let's create your password`}
          </Text>
          {leadProfileCookie?.email && (
            <Flex alginItems="center" flexWrap="wrap" lineHeight="1.75">
              <Text inline as="p" marginRight={1}>
                {t`your username is the e-mail address`}
              </Text>
              <Badge variation="foundation.primary">{leadProfileCookie?.email}</Badge>
            </Flex>
          )}
          <Text as="p" mt={2}>
            {t`now, pick a strong password to save the data you filled previously`}
          </Text>
          <Box mt={3}>
            <PasswordForm setShouldShowErrors={setShouldShowErrorAlert} />
          </Box>
        </Box>
      </Flex>
    </Container>
  );
};

export default CreatePasswordPage;
